import { createApi } from '../createApi';
import * as dummy from '../dummy/faqs';
import * as real from '../api/faqs';

const api = createApi(dummy, real);

/** FAQ/문의 서비스 — API_DOCS: 12. 문의 & FAQ / 28. 관리자 - 문의/FAQ */
export const faqService = {
  /* 서비스 (유저용) - FAQ */
  getCategories: api.getFaqCategories,
  getList: api.getFaqs,
  getById: api.getFaqById,

  /* 서비스 (유저용) - 문의 */
  createInquiry: api.createInquiry,
  getInquiries: api.getInquiries,
  getInquiryById: api.getInquiryById,

  /* 관리자 - FAQ */
  adminGetList: api.getAdminFaqs,
  adminCreate: api.createFaq,
  adminUpdate: api.updateFaq,
  adminDelete: api.deleteFaq,

  /* 관리자 - 문의 */
  adminGetInquiries: api.getAdminInquiries,
  adminGetInquiryById: api.getAdminInquiryById,
  adminAnswerInquiry: api.answerInquiry,
};
